import React, { FC } from 'react'

import { Trans } from 'react-i18next'

import { useStyletron } from 'parkdepot-shared/theme'
import { t } from 'i18next'
import { Link } from 'react-router-dom'
import { lotRouteLongDuration } from '../../views/Lot/route'
import { WarningTextContainer, WarningIcon, WarningList, WarningText } from './SubscriptionsWarning.style'

interface Props {
    lotId: string
}

const SubscriptionsWarning: FC<Props> = ({ lotId }) => {
    const [css, theme] = useStyletron()

    return (
        <WarningTextContainer>
            <WarningIcon className="wemolo-warning-circle" />
            <WarningList>
                <WarningText>{t('lot.subscriptionsHintOne')}</WarningText>
                <WarningText>
                    <Trans
                        i18nKey="lot.subscriptionsHintTwo"
                        components={{
                            1: (
                                <Link
                                    to={lotRouteLongDuration(lotId)}
                                    className={css({
                                        color: theme.colors.primary
                                    })}
                                ></Link>
                            )
                        }}
                    ></Trans>
                </WarningText>
            </WarningList>
        </WarningTextContainer>
    )
}

export default SubscriptionsWarning
